import { Card } from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import convertUtils from 'convert-units';
import moment from "moment/moment";


export function InfoCard({ marker, removeMarkerClick, selected = false }) {
    return (
        <Card
            sx={{
                position: "absolute",
                bottom: 16,
                left: selected ? "calc(22rem - 1rem)" : 16,
                padding: 2,
                backgroundColor: "white",
            }}
        >
            <MDTypography sx={{ fontSize: "20px" }}>
                {marker.info ? <h5 style={{ textAlign: 'center' }}>{marker.info}(Route: {marker.position.route_id})</h5> : <h5 style={{ textAlign: 'center' }}>{marker.type.charAt(0).toUpperCase() + marker.type.slice(1)} Point (Route: {marker.position.route_id})</h5>}
            </MDTypography>
            <MDTypography sx={{ fontSize: "20px" }}>
                Time: {moment(marker.position.timestamp).format("MMMM DD, YYYY h:mm:ss A")}
            </MDTypography>
            <MDTypography sx={{ fontSize: "20px" }}>
                Latitude: {marker.position.latitude}
            </MDTypography>
            <MDTypography sx={{ fontSize: "20px" }}>
                Longitude: {marker.position.longitude}
            </MDTypography>
            <MDTypography sx={{ fontSize: "20px" }}>
                Speed: {convertUtils(marker.position.speed).from('km/h').to('m/h').toFixed(2)} m/h
            </MDTypography>
            <MDTypography sx={{ fontSize: "20px" }}>
                Heading: {marker.position.heading}
            </MDTypography>
            <MDButton color="dark" onClick={() => removeMarkerClick()}>
                Close
            </MDButton>
        </Card>
    )
}

export function LastLocationCard({ address, isTabletOrMobile }) {
    return (
        <Card
            sx={{
                position: "absolute",
                bottom: 70,
                left: 16,
                padding: 1,
                backgroundColor: "white !important",
                width: isTabletOrMobile ? '75%' : '20%',
            }}
        >
            <strong>Last Known Location:</strong>
            <p style={{ margin: 0 }}>{address}</p>
        </Card>
    )
}

export function RouteInfoCard({ route, closeHighlightRoute }) {
    return (
        <Card
            sx={{
                position: "absolute",
                bottom: 16,
                left: 16,
                padding: 2,
                backgroundColor: "white",
            }}
        >
            <MDTypography sx={{ fontSize: "20px" }}>
                Route #{route.route_id}
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px" }}>
                Start Route: {route.start_time}
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px" }}>
                End Route: {route.end_time}
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px" }}>
                Start Latitude: {route.start_latitude}
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px" }}>
                End Latitude: {route.end_latitude}
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px" }}>
                Start Longitude: {route.start_longitude}
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px" }}>
                End Longitude: {route.end_longitude}
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px" }}>
                Total Distance: {route.total_distance}
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px" }}>
                Total Duration: {route.total_duration}
            </MDTypography>
            <MDButton color="dark" onClick={() => closeHighlightRoute(null)}>
                Close
            </MDButton>
        </Card>
    )
}
